module.exports = __webpack_public_path__ + "img/捐赠证书2.cb091b0e.jpg";